import { runInAction, makeAutoObservable, action, extendObservable, set } from 'mobx';
import PartnersService from 'services/partnersService';
import SubscriptionService from 'services/subscriptionService';

import { isSuperAdmin } from 'helpers/usersRolesHelper';
import lsConstants from 'constants/local-storage';

class DomainData {
  getDefaultStoreProps = () => ({
    currentUser: null,
    currentSP: null,
    SPlist: [],
    serviceProvidersDataLoaded: false,
    serviceProvidersDataLoading: false,
    subscriptionAccessLoaded: false,
    subscriptionAccess: {
      label: false,
      dashboard: false,
      activity: false,
    },
  });

  constructor() {
    makeAutoObservable(this);
    extendObservable(this, { ...this.getDefaultStoreProps() });
  }

  @action
  reset() {
    set(this, this.getDefaultStoreProps());
  }

  @action
  resetInitialData = () => {
    this.currentUser = null;
    this.currentSP = null;
    this.SPlist = [];
    this.serviceProvidersDataLoaded = false;
    this.serviceProvidersDataLoading = false;
  };

  setCurrentUser = user => {
    this.currentUser = user;
    localStorage.setItem(lsConstants.CURRENT_USER, JSON.stringify(user));
  };

  getCurrentUser = () => {
    if (this.currentUser) {
      return this.currentUser;
    }
    runInAction(() => {
      this.currentUser = JSON.parse(localStorage.getItem(lsConstants.CURRENT_USER));
    });
    return this.currentUser;
  };

  userIsSuperAdmin = () => {
    const curr = this.getCurrentUser();
    return isSuperAdmin(curr);
  };

  loadServiceProvidersNames = async () => {
    this.serviceProvidersDataLoading = true;
    try {
      const response = await PartnersService.getPartnersNames();
      if (response?.data?.data) {
        this.SPlist = response.data.data;
        this.serviceProvidersDataLoaded = true;
        this.serviceProvidersDataLoading = false;
      }
    } catch (err) {
      this.serviceProvidersDataLoading = false;
    }
  };

  getPartnersNames = async () => {
    if (this.serviceProvidersDataLoaded) {
      return this.SPlist;
    }
    if (this.serviceProvidersDataLoading) {
      return new Promise(resolve => {
        const checkData = () => {
          if (this.serviceProvidersDataLoaded) {
            resolve(this.SPlist);
          } else {
            setTimeout(checkData, 1000);
          }
        };
        checkData();
      });
    }
    await this.loadServiceProvidersNames();
    return this.SPlist;
  };

  // get service provider data
  getSPListNames = async (force = false) => {
    if (this.SPlist?.length > 0 && force !== true) {
      return this.SPlist;
    }
    this.serviceProvidersDataLoaded = false;
    this.serviceProvidersDataLoading = false;
    return this.getPartnersNames();
  };

  getCurrentSP = () => {
    if (this.currentSP) {
      return this.currentSP;
    }
    runInAction(() => {
      this.currentSP = localStorage.getItem(lsConstants.CURRENT_SERVICE_PROVIDER);
    });
    return this.currentSP;
  };

  setCurrentSP = value => {
    this.currentSP = value;
    localStorage.setItem(lsConstants.CURRENT_SERVICE_PROVIDER, value);
  };

  checkSubscriptionAccess = async isUserSuperAdmin => {
    if (isUserSuperAdmin) {
      this.subscriptionAccess.label = true;
      this.subscriptionAccess.dashboard = true;
      this.subscriptionAccess.activity = true;
    } else {
      const response = await SubscriptionService.checkSubscriptionAccess();
      if (response?.data) {
        this.subscriptionAccess = response.data;
      }
    }
    this.subscriptionAccessLoaded = true;
  };

  getSubscriptionAccess = page => this.subscriptionAccess[page];

  getSubscriptionAllAccess = () => this.subscriptionAccess;

  isSubscriptionAccessLoaded = () => this.subscriptionAccessLoaded;
}

export default new DomainData();
